import { isFiniteNumber, DisplayUnit, DisplayUnitMap } from '@core';
import { CorridorParameterMargins } from '@data';
import { useMemo } from 'react';

function isFloat(num: number) {
    return num % 1 !== 0;
}

// if the range is less than this in cm or ratio you the stepper does 0.5 increments
const RANGE_THRESHOLD = 4;

type UseGoalParameterSetStepperArgs = {
    displayUnit: DisplayUnit;
    corridorMargins?: CorridorParameterMargins;
};

export const useGoalParameterSetStepper = ({ displayUnit, corridorMargins }: UseGoalParameterSetStepperArgs) => {
    const stepper = useMemo(() => {
        if (displayUnit === DisplayUnitMap.in) {
            return 0.25;
        }
        if (
            corridorMargins &&
            isFiniteNumber(corridorMargins.innerMax) &&
            isFiniteNumber(corridorMargins.innerMin) &&
            corridorMargins.unit === DisplayUnitMap.cm
        ) {
            const { innerMin, innerMax } = corridorMargins;
            const range = Math.abs(innerMin - innerMax);

            if (isFloat(innerMin) || isFloat(innerMax) || range <= RANGE_THRESHOLD) {
                return 0.5;
            }
        }

        // Default to a stepper of 1 for all other cases.
        return 1;
    }, [displayUnit, corridorMargins]);
    return stepper;
};
